import { library } from '@fortawesome/fontawesome-svg-core';
import { far } from '@fortawesome/pro-regular-svg-icons';
import { faCircle as circleSolid, faCog as cogSolid } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon, FontAwesomeLayers, FontAwesomeLayersText } from '@fortawesome/vue-fontawesome'
import { faSalesforce, faOpera, faTwitterSquare, faFacebookSquare } from '@fortawesome/free-brands-svg-icons';

library.add(far, faSalesforce, faOpera, faTwitterSquare, faFacebookSquare, circleSolid, cogSolid);

const FontAwesome = {
  install(Vue) {
    Vue.component('font-awesome-icon', FontAwesomeIcon);
    Vue.component('font-awesome-layers', FontAwesomeLayers)
    Vue.component('font-awesome-layers-text', FontAwesomeLayersText)
  }
}
export default FontAwesome;
